import { render, staticRenderFns } from "./addService.vue?vue&type=template&id=5250db9b&scoped=true&"
import script from "./addService.vue?vue&type=script&lang=js&"
export * from "./addService.vue?vue&type=script&lang=js&"
import style0 from "./addService.vue?vue&type=style&index=0&id=5250db9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5250db9b",
  null
  
)

export default component.exports